module.exports = __webpack_public_path__ + "img/55560d0d48c36eca2d641895c285791f.png";